<template>
    <div class="grid p-fluid">
    <div class="col-12">
        <BlockUI :blocked="submittedConv" class="mt-4">
        <Card>
            <template #title>
            <div class="flex align-items-center">
                <i class="pi pi-file-import mr-2"></i>
                <span>Archivos Conversión</span>
            </div>
            </template>
            
            <template #content>
           
            <div class="flex flex-column gap-4">
                <!-- Sección de carga -->
                <div class="surface-card p-4 border-round">
                <h4 class="mt-0 mb-3">Cargar archivo nuevo</h4>
                <div class="col-12">
                    <Message severity="warn">
                    Los archivos deben tener como primera fila los nombres de columna así como deben ser con el número y orden de columnas del archivo original.
                    </Message>
                </div>
                
                <div class="grid formgrid">
                    <div class="field col-12 md:col-4">
                    <label for="QnaC" class="block font-medium mb-2">Quincena <span class="text-red-500">*</span></label>
                    <InputText 
                        id="QnaC" 
                        v-model="qnaConv" 
                        :class="{'p-invalid': submittedConv && !qnaConv}" 
                        class="w-full"
                        placeholder="Ej. 01, 02, etc."
                    />
                    <small class="p-error" v-if="submittedConv && !qnaConv">Requerido</small>
                    </div>
                    
                    <div class="field col-12 md:col-4">
                    <label for="anioC" class="block font-medium mb-2">Año <span class="text-red-500">*</span></label>
                    <InputNumber 
                        id="anioC" 
                        v-model="anioConv" 
                        :class="{'p-invalid': submittedConv && !anioConv}"
                        class="w-full"
                        placeholder="Ej. 2023"
                    />
                    <small class="p-error" v-if="submittedConv && !anioConv">Requerido</small>
                    </div>
                    
                    <div class="field col-12 md:col-4 flex align-items-end">
                    <FileUpload
                        ref="filConv"
                        mode="basic"
                        :maxFileSize="25000000"
                        :customUpload="true"
                        @uploader="myUploaderConv"
                        invalidFileSizeMessage="El archivo debe ser de máximo 25MB"
                        chooseLabel="Seleccionar Archivo"
                        accept=".xlsx,.xls,.csv"
                        @select="archivoSeleccionadoConv"
                        class="w-full"
                    />
                    </div>
                </div>
                
                <Message v-if="muestraMsgConv" severity="info" :closable="false" class="mt-3">
                    Pulse de nuevo sobre el botón para enviarlo. El proceso puede tardar varios minutos, por favor no cierre ni actualice la página. Al cargar un nuevo archivo el anterior se remplaza.
                </Message>
                </div>
                
                <!-- Historial de importaciones -->
                <div class="surface-card p-4 border-round">
                <h4 class="mt-0 mb-3">Historial de Importaciones</h4>
                
                <DataTable 
                    :value="lstImportacionesConv"  
                    scrollHeight="200px" 
                    :scrollable="true"
                    :loading="submittedConv"
                    stripedRows
                    class="p-datatable-sm"
                >
                    <Column field="Qna" header="Quincena" headerStyle="width: 100px"></Column>
                    <Column field="Anio" header="Año" headerStyle="width: 100px"></Column>
                    <Column field="Fecha_carga" header="Fecha" headerStyle="width: 150px">
                    <template #body="slotProps">
                        <Tag :value="getFechaWCF(slotProps.data.Fecha_carga,true)" icon="pi pi-calendar" />
                    </template>
                    </Column>
                    <Column field="Registros" header="Registros" headerStyle="width: 120px"></Column>
                    <Column field="Importados" header="Importados" headerStyle="width: 120px"></Column>
                    <Column field="Estatus" header="Estatus" headerStyle="width: 150px">
                    <template #body="slotProps">
                        <Tag 
                        :value="slotProps.data.Actual?'ACTUAL':slotProps.data.Comparacion?'COMPARACIÓN':'N/A'"
                        :severity="slotProps.data.Actual?'success':slotProps.data.Comparacion?'warning':'info'"
                        icon="pi pi-info-circle"
                        />
                    </template>
                    </Column>
                </DataTable>
                </div>
            </div>
            </template>
        </Card>
        </BlockUI>
    </div>
    </div>
</template>

<script>
import Srvr from "../../service/CatalogoConversion";
export default {
    data(){
        return {
            muestraMsgConv:false,
            anioConv:null,
            qnaConv:null,
            submittedConv:false,
            mensajeConv:'',
            blockConv:false,
            lstImportacionesConv: [],
        }
    },
    methods: {
        getFechaWCF(fecha,hora){
            if(fecha){
                var millis = fecha
                .replace("/Date(","")
                .replace("/","")
                .replace(")","");           
                
                millis = millis * 1;

                if(millis>0){  
                var mfecha = new Date(millis);
            
                var res = mfecha.getDate() < 10 ? "0" + mfecha.getDate(): mfecha.getDate();
                res+="/";
                res+=(mfecha.getMonth() + 1) < 10 ? "0" + (mfecha.getMonth() + 1):(mfecha.getMonth() + 1);
                res+="/";
                res+=mfecha.getFullYear();

                if(hora){
                    res+=" ";
                    res+=(mfecha.getHours());
                    res+=":"
                    res+=mfecha.getMinutes() < 10 ? "0" + mfecha.getMinutes(): mfecha.getMinutes();
                }

                return res;
                }
                else{        
                return "N/D";
                }
            }
        },
        cargaInicialConv(){
            var t =  this;
            var ctlSvr = new Srvr();
            
            ctlSvr.GetImportaciones(t,'CONV').then((res)=>{
                //console.log(res);
                t.lstImportacionesConv = res;
            });
            t.qnaConv = null;
            t.anioConv = null;
            t.submittedConv = false;
            t.muestraMsgConv = false;
            t.mensajeConv = '';
        },
        archivoSeleccionadoConv(e){                 
            if(e.files.length>0){
                this.muestraMsgConv = true;
            }
            else{
                this.muestraMsgConv = false;
            }
        },
        myUploaderConv(event) {
            //event.files == files to upload
            //console.log(event.files[0]);
            if(!this.qnaConv || !this.anioConv)
                return;
                
            this.submittedConv = true;

            this.cargaArchivoConv(event.files[0]);
        },
        cargaArchivoConv(mfile) {
            var t = this;

            var file = mfile;
            t.mensajeConv = "";

            //console.log(file);

            var ext = file.name.slice(((file.name.lastIndexOf(".") - 1) >>> 0) + 2);

            //console.log(ext);

            if (ext.length > 0 && ext.length <= 4) {
                if (file.size <= 25000000) {
                var ctlSvr = new Srvr();
                var reader = new FileReader();
                var fileByteArray = [];
                reader.readAsArrayBuffer(file);
                reader.onloadend = function (evt) {
                    if (evt.target.readyState == FileReader.DONE) {
                        var arrayBuffer = evt.target.result,
                            array = new Uint8Array(arrayBuffer);
                        for (var i = 0; i < array.length; i++) {
                            fileByteArray.push(array[i]);
                        }

                        var newFileName = file.name; //+ "." + ext;
                        newFileName = newFileName.replace(" ", "");
                        newFileName = newFileName.replace("_", "");
                        //console.log(newFileName);

                        var formData = {
                            fileBytes: fileByteArray,
                            fileName: newFileName,
                            Qna: t.qnaConv,
                            Anio: t.anioConv,
                            Tipo: 'CONV',                                                
                        };

                        //console.log(formData);

                        ctlSvr.cargaArchivo(t, formData).then((res) => {
                            //console.log(res);
                            t.mensajeConv = "Se cargo el archivo. Registros en el archivo: " + res.REGISTROS + ", guardados en la base de datos: " + res.INSERTADOS;
                            t.$refs.filConv.clear();
                            t.cargaInicialConv();
                        })
                        .catch(function(error){
                            console.log(error);
                            t.submittedConv = false;
                        });
                    }
                };
                } else {
                t.$toast.add({
                    severity: "warn",
                    summary: "ALERTA",
                    detail:
                    "El archivo sobrepasa el limite de 25Mb, por favor intenta con otro archivo",
                    life: 6000,
                });
                }
            } else {
                t.$toast.add({
                severity: "warn",
                summary: "ALERTA",
                detail:
                    "El archivo no cuenta con una extensión de tipo de archivo valida. Intente con otro archivo",
                life: 6000,
                });
            }
        },
    },
    mounted() {
		var t = this;		
        t.cargaInicialConv();
	},
}
</script>

<style scoped>
  /* Estilos personalizados */
  :deep(.p-fileupload-buttonbar) {
    padding: 0;
    background: none;
    border: none;
  }
  
  :deep(.p-fileupload-content) {
    display: none;
  }
  
  :deep(.p-fileupload-choose) {
    width: 100%;
  }
  
  :deep(.p-datatable) {
    font-size: 0.9rem;
  }
  
  :deep(.p-datatable .p-datatable-thead > tr > th) {
    background-color: var(--surface-50);
    font-weight: 600;
  }
  </style>